window.addEventListener('load', () => {

    const navbar = document.querySelector('.navbar');
    window.addEventListener('scroll', () => {
        if (window.pageYOffset >= 5) {
            navbar.classList.add('active');
        } else {
            navbar.classList.remove('active');
        }
    })
})